import React from "react";

const Info = () => {
  return (
    <div className="about__info grid">
      <div className="about__box">
        <i className="bx bx-award about__icon" />
        <h3 className="about__title">Experience</h3>
        <span className="about__subtitle">Working since February 2023</span>
      </div>

      <div className="about__box">
        <i className="bx bx-briefcase-alt about__icon" />
        <h3 className="about__title">Completed</h3>
        <span className="about__subtitle">
          Ironhack bootcamp 9 intensive weeks (MERN Stack)
        </span>
      </div>

      <div className="about__box">
        <i className="bx bx-bulb about__icon" />
        <h3 className="about__title">Mindset</h3>
        <span className="about__subtitle">
          Positive
          <br />
          Proactive
          <br />
          Teamwork
          <br />
          ...
        </span>
      </div>
    </div>
  );
};

export default Info;
